// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__e62L7","footer_container":"Footer_footer_container__vylNB","footer_span":"Footer_footer_span__EBFCK"};